module.exports = __webpack_public_path__ + "img/logo-comment.09744581.svg";